import React from 'react';
import { IconButton, IconButtonProps, MenuItem, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { TrashIcon } from '@sanity/icons';
import { EditButtonIcon } from '@shared/custom-icons';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Menu, MenuButton } from '@retail/components';
import { useRoundingTFunction } from '@retail/rounding/i18n';

interface Props {
  onCopy?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

const MenuButtonComponent: React.FC<IconButtonProps> = (props) => (
  <IconButton {...props}>
    <MenuIcon />
  </IconButton>
);

export const PriceRoundingActionsMenu: React.FC<Props> = ({ onEdit, onCopy, onDelete }) => {
  const theme = useTheme();
  const palette = theme.vars.palette;
  const t = useRoundingTFunction();

  if (!onCopy && !onEdit && !onDelete) {
    return null;
  }

  return (
    <Menu>
      {({ onClose }) => (
        <>
          <MenuButton component={MenuButtonComponent} />
          {!!onCopy && (
            <MenuItem
              onClick={() => {
                onCopy();
                onClose();
              }}
            >
              {t('rounding.actions.copyRule')}
              <ContentCopyIcon fontSize="small" />
            </MenuItem>
          )}
          {!!onEdit && (
            <MenuItem
              onClick={() => {
                onEdit();
                onClose();
              }}
            >
              {t('rounding.actions.editRule')}
              <EditButtonIcon fontSize="small" />
            </MenuItem>
          )}
          {!!onDelete && (
            <MenuItem
              onClick={() => {
                onDelete();
                onClose();
              }}
            >
              {t('rounding.actions.deleteRule')}
              <TrashIcon fontSize="25px" color={palette.warning.main} />
            </MenuItem>
          )}
        </>
      )}
    </Menu>
  );
};
